import { createStyles, makeStyles } from '@material-ui/core/styles';
var useStyles = makeStyles(function () {
  return createStyles({
    trigger: {
      cursor: 'pointer',
      width: 'fit-content'
    }
  });
});
export default useStyles;